<template>
  <div id="themes-page" class="bg-gray-20 pb-6 md:pb-15">
    <mobile-sub-filter />
    <product-list-banners />
    <product-list />
  </div>
</template>

<script setup lang="ts">
import MobileSubFilter from '@/components/search/filter/mobile-sub-filter.vue'
import ProductListBanners from '@/components/product/product-list-banners.vue'
import ProductList from '@/components/product/product-list.vue'

import { useCategoryStore } from '@/store/category'

const route = useRoute()

const categoryStore = useCategoryStore()

const tagId = computed(() => route.params.tagId as string)

await useFilters({ tagId })

onMounted(() => {
  categoryStore.fetchTagDetail(tagId.value)
})
</script>
